import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Configuration } from '../../app.constants';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

export class User {
    constructor(
        public username: string,
        public password: string) { }
}

@Injectable()
export class AuthService {

    constructor(
        private _router: Router,
        private _http: Http, private _conf: Configuration) { }

    logout() {
        localStorage.removeItem("user");
        // this._router.navigate(['Login']);
    }
    auhenticateuser: any;
    login(user: any) {
        user.bodyAuth = this._conf.bodyAuth
        let body = JSON.stringify(user);
        // //console.log(user);

        return this._http.post(this._conf.Url + 'login', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                //console.log(res);
                if (res.token) {
                    localStorage.setItem('authToken', res.token);
                    localStorage.setItem('username', res.username);

                    //  this._router.navigate(['Home']);
                    // return res.code;
                }
                return res;
            })
        //.catch(this.handleError);
    }

    register(user: any) {
        user.bodyAuth = this._conf.bodyAuth;
        let body = JSON.stringify(user);


        // console.log(body);

        return this._http.post(this._conf.Url + 'register', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                //console.log(res);
                if (res.code == 200) {
                    if (res.response.authToken) {
                        localStorage.setItem('authToken', res.response.authToken);
                        localStorage.setItem('username', res.response.username);
                    }
                }
                // if (res.token) {
                //     localStorage.setItem('user', res.token);S
                //     // this._router.navigate(['Pages']);
                //     return res.code;
                // }
                return res;
            })
    }

    phoneNumbercheck(user: any) {
        user.bodyAuth = this._conf.bodyAuth;
        let body = JSON.stringify(user);

        // console.log(body);

        return this._http.post(this._conf.Url + 'phoneNumberCheck', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {                
                return res;
            })
    }

    generateOTPCheck(user: any) {
        user.bodyAuth = this._conf.bodyAuth;
        let body = JSON.stringify(user);

        // console.log(body);

        return this._http.post(this._conf.Url + 'otp', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {                
                return res;
            })
    }

    signupemailcheck(user: any) {
        user.bodyAuth = this._conf.bodyAuth;
        let body = JSON.stringify(user);


        // console.log(body);

        return this._http.post(this._conf.Url + 'emailCheck', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                //console.log(res);
                // if (res.code != 2004 && res.code != 1995) { 
                //     if (res.response.authToken) {
                //         localStorage.setItem('authToken', res.response.authToken);
                //         localStorage.setItem('username', res.response.username);
                //     }
                // }
                // if (res.token) {
                //     localStorage.setItem('user', res.token);S
                //     // this._router.navigate(['Pages']);
                //     return res.code;
                // }
                return res;
            })
    }

    signupusernamecheck(user: any) {
        user.bodyAuth = this._conf.bodyAuth;
        let body = JSON.stringify(user);


        //console.log(body);

        return this._http.post(this._conf.Url + 'usernameCheck', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                //console.log(res);
                // if (res.code != 2004 && res.code != 1995) { 
                //     if (res.response.authToken) {
                //         localStorage.setItem('authToken', res.response.authToken);
                //         localStorage.setItem('username', res.response.username);
                //     }
                // }
                // if (res.token) {
                //     localStorage.setItem('user', res.token);S
                //     // this._router.navigate(['Pages']);
                //     return res.code;
                // }
                return res;
            })
    }

    resetPassword(user: any) {
        let body = JSON.stringify(user);
        //console.log(body);



        return this._http.post(this._conf.Url + 'resetPassword', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                //console.log(res);
                // if (res.token) {
                //     localStorage.setItem('user', res.token);S
                //     // this._router.navigate(['Pages']);
                //     return res.code;
                // }
                return res;
            })
    }


    changePassword(user: any) {
        // //console.log(user);
        // user.passwordResetLink = 'AmB8qLwREFq6FvKW67lirq6q63mCxV68';
        let body = JSON.stringify(user);
        //console.log(body);



        return this._http.post(this._conf.Url + 'changePassword', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                //console.log(res);
                // if (res.token) {
                //     localStorage.setItem('user', res.token);S
                //     // this._router.navigate(['Pages']);
                //     return res.code;
                // }
                return res;
            })
    }

    userNameCheckList(user: any) {
        let body = {
            bodyAuth: this._conf.bodyAuth,           
            username: user
        }
        // console.log(body);

        return this._http.post(this._conf.Url + 'usernameCheck', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                console.log(res);                
                return res;
            })

    }

    registerfacebooklogin(user: any) {
        let body = {
            bodyAuth: this._conf.bodyAuth,
            email: user.email,
            signupType: 1,
            deviceType: 3,
            accessToken: user.id,
            password:user.password,
            username: user.name.toLowerCase().replace(/ /g, '')
        }
        // console.log(body);

        return this._http.post(this._conf.Url + 'register', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                // console.log(res);
                if (res.code != 2005) {
                    if (res.response.authToken) {
                        localStorage.setItem('authToken', res.response.authToken);
                        localStorage.setItem('username', res.response.username);
                    }
                }
                return res;
            })
    }

    facebooklogin(user: any) {
        let body = {
            bodyAuth: this._conf.bodyAuth,
            facebookAuth: 1,
            facebookId: user.id,
            username: user.name.toLowerCase().replace(/ /g, '')
        }
        // console.log(body);

        return this._http.post(this._conf.Url + 'login', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                // console.log(res);
                if (res.token) {
                    localStorage.setItem('authToken', res.token);
                    localStorage.setItem('username', res.username);
                }
                return res;
            })
    }


    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    checkCredentials() {
        if (localStorage.getItem("authToken") === null) {
            this._router.navigate(['Login']);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/sharedServices/AuthService/auth.service.ts
 **/